var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lorc-sliced-bread-gradient-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(1,-1)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.97 14.438C99.288 14.456 59.192 25.668 40.688 45.625C10.036 78.683 41.926 132.415 17.968 213.688C9.355 242.908 92.146 311.622 140.156 365.313C137.244 357.398 136.841 348.778 139 340.625L139 339.937L139.47 338.5C157.024 285.094 152.158 256.808 138.22 213.187C133.026 196.937 133.996 181.457 140 168.375C146.004 155.293 156.6 144.797 169.625 136.562C195.675 120.092 231.82 111.949 267.938 110.906C272.437 110.773 276.938 110.752 281.438 110.844C304.868 111.336 327.748 114.917 347.344 122.064C341.552 116.024 335.001 109.941 328 103.844C286.15 79.691 172.493 85.452 119.97 119.969C153.035 75.743 234.74 53.775 304.5 84.562C296.243 78.099 287.762 71.7 279.375 65.436C238.262 40.686 123.365 46.27 70.47 81.03C102.665 37.97 181 15.983 249.5 43.28C220.747 23.468 180.323 14.42 141.97 14.437Z",
    className: "",
    fill: "#b57204",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.75 129.468C272.655 129.474 270.567 129.502 268.47 129.563C234.9 130.533 201.29 138.678 179.625 152.375C168.793 159.223 161.052 167.259 156.969 176.155C152.884 185.053 152.026 194.969 156.029 207.5C170.219 251.9 175.581 287.25 157.686 342.72L157.686 342.937L157.218 344.344C155.921 348.284 156.015 356.242 159.028 361.814C162.044 367.384 166.728 371.687 178.778 371.687C186.078 371.687 195.765 371.667 204.748 371.657C226.584 355.13 252.098 336.474 271.123 321.687C281.243 313.823 293.897 312.067 305.248 312.375C316.598 312.685 326.656 315.009 333.811 318.438C353.533 327.882 370.888 334.073 388.811 338.563C388.668 337.593 388.471 336.756 388.248 336.093C372.026 288.119 364.138 245.713 379.842 198.375C383.922 186.077 383.072 176.731 379.154 168.531C375.236 160.333 367.738 153.001 357.029 146.938C338.289 136.331 310.239 130.238 281.029 129.532C278.936 129.483 276.843 129.463 274.749 129.472Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.094 331.031C302.544 331.031 302.01 331.046 301.469 331.064C293.897 331.31 286.826 333.149 282.593 336.439C258.223 355.379 223.996 380.149 200.313 398.626C195.643 402.268 194.129 405.15 193.749 406.656C193.369 408.166 193.503 408.821 194.562 410.314C196.678 413.299 204.352 417.277 211.968 417.22C266.692 416.815 309.358 429.916 345.373 447.25C364.903 456.65 388.821 456.972 412.093 451.313C435.363 445.653 457.731 434.003 473.123 421.125C488.515 408.247 495.453 394.515 494.186 387.187C493.552 383.523 491.604 380.197 485.436 376.531C479.266 372.867 468.872 369.516 453.748 367.876C404.356 362.523 369.795 356.374 325.748 335.282C322.42 333.688 313.504 331.302 304.748 331.065C304.196 331.048 303.644 331.037 303.092 331.033Z",
    className: "",
    fill: "#ffe0af",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.344 421.531C495.232 426.371 490.4 431.025 485.124 435.439C467.229 450.412 442.789 463.084 416.531 469.469C390.275 475.856 361.951 475.967 337.281 464.095C303.117 447.651 263.831 435.525 212.126 435.907C204.166 435.967 196.348 434.217 189.813 430.501C191.723 446.761 201.497 460.666 219.157 460.531C270.379 460.141 300.48 472.721 336.97 486.064C394.35 507.044 499.344 474.471 499.344 436.939L499.344 421.53Z",
    className: "selected",
    fill: "#b57204",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBread);
export default __webpack_public_path__ + "static/media/Bread.5b57eee7394505b1c18d1dc0045cf95b.svg";
export { ForwardRef as ReactComponent };